import { faShareNodes, faTableColumns } from '@fortawesome/pro-light-svg-icons';
import { IAction } from './interfaces';
export const actions: IAction[] = [
  {
    context: 'savedDashboards',
    id: 'Sharing',
    displayName: 'Deling',
    icon: faShareNodes,
    isVisible: selctedCount => selctedCount > 0,
  },
  {
    context: 'savedDashboards',
    id: 'ColumnChooser',
    displayName: 'Kolonner',
    icon: faTableColumns,
    isVisible: () => true,
  },
];
